export var MICROSOFT_CALENDAR_TYPE = 'microsoft_365';
/**
 * Affirmative check: returns true only when we know the user can create a
 * request-only booking with the current calendar integration state.
 * Defaults to false while loading or when capability is not proven.
 */
export function canCreateRequestWithPersonalCalendar(input) {
    // Until calendar integration state has loaded, we cannot know for sure.
    if (input.isLoadingCalendarIntegration) {
        return false;
    }
    // Org does not prefer personal booking: space-calendar path works unless
    // this is a Microsoft managed space (those require a personal MS calendar).
    if (!input.personalBookingEnabled) {
        return !(input.spaceCalendarType === MICROSOFT_CALENDAR_TYPE &&
            input.isManagedSpace);
    }
    // Personal booking requires a selected writable calendar to book onto.
    if (input.calendarsCount === 0 || !input.selectedCalendarRemoteType) {
        return false;
    }
    // Microsoft managed spaces require a Microsoft personal calendar.
    if (input.isManagedSpace &&
        input.spaceCalendarType === MICROSOFT_CALENDAR_TYPE) {
        return input.selectedCalendarRemoteType === MICROSOFT_CALENDAR_TYPE;
    }
    return true;
}
